// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"7bf9f889","938":"82d5f197"}[chunkId] + ".chunk.css";
};